import mapKnownValues from "../utils/mapKnownValues";

export type TransferEarningsResponse = {
  dollarsPerYear: number;
  dollarsOver15YearsConsolidation: number;
};

export default class TransferEarnings {
  dollarsPerYear = 0;
  dollarsOver15YearsConsolidation = 0;

  constructor(params: Partial<TransferEarnings>) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: TransferEarningsResponse) {
    return new TransferEarnings(response);
  }
}
